var $ = window.jQuery;
import productAccommodation from './shared/product-accommodation'

export default {
  loaded() {
    function updatePriceDisplay(prevPrice, price, duration, $this = null) {
      var html;
      let isAddon = $('main#product-main').data('is-adddon');

      //round price and convert to decimal
      price = !isAddon ? Math.ceil(price / 500) * 500 : price;
      price = (price /100).toFixed(2);

      prevPrice = !isAddon ? Math.ceil(prevPrice / 500) * 500 : prevPrice;
      prevPrice = (prevPrice / 100).toFixed(2);

      let depositPerc = $('main#product-main').data('deposit-perc');
      let deposit = Number(price * (depositPerc / 100)).toFixed(2)

      if(parseInt(price) < parseInt(prevPrice)) {
        html = '<div><span class="text-2xl font-bold text-gray-500 line-through leading-8">&pound' + prevPrice  + '</span>&nbsp;&pound;' + price  + '</div>'
      } else {
        html = '<div>&pound' + price + '</div>'
      }

      $('.price-summary').html(html)


      $('.deposit-summary').html('<span class="font-bold text-gray-900">&pound' + deposit + '</span> deposit due upon booking. <span class="font-bold text-gray-900">&pound' + (price - deposit).toFixed(2) + '</span> due nearer to trip start date.')

      //populate hidden input values on book now form (for booking page)
      $('form.book-now input[name="duration"]').val(duration)
      $('form.book-now input[name="price"]').val(price)
      $('form.book-now input[name="deposit"]').val(deposit)

      if($('.seasonal-pricing-data').length) {
        if($this !== null) {
          //specifix box has changed
          let $thisForm = $this.closest('.pricing-box')

          $thisForm.find('input[name="season"]').val($thisForm.find('select[name="seasons"] option:selected').text())
          $thisForm.find('input[name="budget"]').val($thisForm.find('select[name="budgets"] option:selected').text())
        } else {
          //on load
          let seasonVal = $('.seasonal-pricing-data select[name="seasons"] option').first().text()
          $('form.book-now input[name="season"]').val(seasonVal)

          let budgetVal = $('.seasonal-pricing-data select[name="budgets"] option:selected').first().text()
          $('form.book-now input[name="budget"]').val(budgetVal)
        }
      }
    }

    //////////////////////
    // SIMPLE PRICING //
    //////////////////////
    if($('.simple-pricing-data').length) {
      let priceHidden = $('.pricing-box').hasClass('product-hide-pricing');
      if(!priceHidden) {
        updatePriceDisplay($('.simple-pricing-data').find('option:selected').first().data('prev-price'), $('.simple-pricing-data').find('option:selected').first().data('price'), $('.simple-pricing-data').find('option:selected').first().val())
      }
      $('.simple-pricing-data select').on('change', function() {
        var selectedOption = $(this).find('option:selected').val()

        $('.simple-pricing-data select').val(selectedOption);
        if(!priceHidden) {
          updatePriceDisplay($(this).find('option:selected').data('prev-price'), $(this).find('option:selected').data('price'), selectedOption);
        }
      })
    }

    //////////////////////
    // SEASONAL PRICING //
    //////////////////////
    function populateDurations(priceData, priceHidden) {
      let optionHtml = ''
      let $durationSelect = $('.seasonal-pricing-data').find('select[name="durations"]')

      for (let i = 0; i < priceData.length; i++) {
        optionHtml = '<option value="' + priceData[i].duration_days + '">' + priceData[i].duration_days + ' days</option>';
        $durationSelect.append(optionHtml);
      }
      if(!priceHidden) {
        let duration = $durationSelect.val();
        let selectedDurationObject = priceData.find(obj => obj.duration_days == duration);
        populateSeasons(selectedDurationObject);
      }
    }

    function populateSeasons(selectedObject) {
      // console.log(Object.keys(selectedObject))
      let optionHtml = ''
      let $seasonSelect = $('.seasonal-pricing-data').find('select[name="seasons"]')

      $seasonSelect.find('option').remove()

      for (let key in selectedObject) {
        if(key !== 'duration_days' && key !== 'label') {
          optionHtml = '<option value="' + key + '">' + selectedObject[key].label + '</option>'
          $seasonSelect.append(optionHtml)
        }
      }

      let season = $seasonSelect.val();
      populateBudgets(selectedObject[season])
    }

    function populateBudgets(selectedObject, $this = null) {
      let optionHtml = ''
      let $budgetSelect = $('.seasonal-pricing-data').find('select[name="budgets"]')

      $budgetSelect.find('option').remove()

      for (let key in selectedObject) {
        if(key !== 'label') {
          optionHtml = '<option value="' + key + '">' + selectedObject[key].label + '</option>'
          $budgetSelect.append(optionHtml)
        }
      }

      let budget = $budgetSelect.val();
      let price = selectedObject[budget].retail_price
      let prevPrice = selectedObject[budget].retail_previous_price
      let duration = $('.seasonal-pricing-data').find('select[name="durations"]').val()

      updatePriceDisplay(prevPrice, price, duration, $this)
    }

    if($('.seasonal-pricing-data').length) {
      const priceData = $('.seasonal-pricing-data').first().data('json');
      let priceHidden = $('.pricing-box').hasClass('product-hide-pricing');
      populateDurations(priceData, priceHidden);
      if(!priceHidden) {
        //SELECT CHANGES
        //Duration changes
        $('.seasonal-pricing-data').find('select[name="durations"]').on('change', function () {
          let selectedDuration = $(this).val()
          let selectedDurationObject = priceData.find(obj => obj.duration_days == selectedDuration)
          populateSeasons(selectedDurationObject)
        });

        //Season changes
        $('.seasonal-pricing-data').find('select[name="seasons"]').on('change', function () {
          let selectedDuration = $(this).closest('.seasonal-pricing-data').find('select[name="durations"]').val()

          let selectedDurationObject = priceData.find(obj => obj.duration_days == selectedDuration)
          let selectedSeason = $(this).val()

          populateBudgets(selectedDurationObject[selectedSeason], $(this))
        });

        //Budget changes
        $('.seasonal-pricing-data').find('select[name="budgets"]').on('change', function () {
          let selectedDuration = $(this).closest('.seasonal-pricing-data').find('select[name="durations"]').val()

          let selectedDurationObject = priceData.find(obj => obj.duration_days == selectedDuration)
          let selectedSeason = $(this).closest('.seasonal-pricing-data').find('select[name="seasons"]').val()
          let selectedBudget = $(this).val()

          let price = selectedDurationObject[selectedSeason][selectedBudget].retail_price
          let prevPrice = selectedDurationObject[selectedSeason][selectedBudget].retail_previous_price
          let duration = selectedDuration

          updatePriceDisplay(prevPrice, price, duration, $(this))
        });
      }
    }

    //////////////////////
    // ACCORDION //
    //////////////////////
    $('.product__accordion').find('button').on('click', function() {
      $(this).closest('.product__accordion-item').find('dt svg').first().toggleClass('-rotate-180 transform');
      $(this).closest('.product__accordion-item').find('dd').first().toggleClass('hidden');
    })

    $('.accommodation__accordion-item').find('button').on('click', function() {
      $(this).closest('.accommodation__accordion-item').find('svg.chevron').first().toggleClass('-rotate-180 transform');
      $(this).closest('.accommodation__accordion-item').find('dd').first().toggleClass('hidden');
    })
    productAccommodation()
  }
}
